import { ThemeMode } from '@interacta-shared/util-common';

const AI_ASSETS_PATH = './assets/shared/images/ai';

/*
 * The two asset families do not share a suffix convention — the logo is
 * `_light`/`_dark`, the wordmark is unsuffixed/`_D` — so the pairs are listed
 * rather than composed from the name.
 */
const AI_THEMED_ASSETS = {
    logo: {
        light: `${AI_ASSETS_PATH}/ai-interacta-logo_light.svg`,
        dark: `${AI_ASSETS_PATH}/ai-interacta-logo_dark.svg`,
    },
    wordmark: {
        light: `${AI_ASSETS_PATH}/ai-interacta-header.svg`,
        dark: `${AI_ASSETS_PATH}/ai-interacta-header_D.svg`,
    },
} as const;

export type AIThemedAsset = keyof typeof AI_THEMED_ASSETS;

export function aiThemedAssetSrc(
    asset: AIThemedAsset,
    mode: ThemeMode,
): string {
    return AI_THEMED_ASSETS[asset][mode];
}

export const AI_LOGO_WHITE_SRC = `${AI_ASSETS_PATH}/ai-interacta-logo_white.svg`;
